import styled from "styled-components";

export const Fullscreen = styled.img`
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  object-position: top;
`;
